import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import Navbarr from "./components/Navbarr";
import MaintenanceBanner from "./components/MaintenanceBanner";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./App.css";
import ScrollToTop from "./ScrollToTop";
import Home from "./pages/Home/Home";
import Reviews from "./pages/Reviews/Reviews";
import Process from "./pages/Process/Process";
import Calendar from "./pages/Calendar/Calendar";
import FAQ from "./pages/FAQ/FAQ";
import About from "./pages/About/About";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Terms from "./pages/Terms/Terms";
import Social from "./components/Social";
import SignIn from "./pages/SignIn/SignIn";
import Dashboard from "./pages/Dashboard/dashboard";
import { SidebarProvider } from "./contexts/SidebarContext";
// import SignUp from "./pages/SignUp/SignUp";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import BookingPage from "./pages/BookingPage";
import ConfirmPassword from "./pages/ConfirmPassword/ConfirmPassword";
import TimeshareDetail from "./components/TimeshareList/TimeshareDetail";
import ChatWithUser from "./components/Chat/ChatWithUser";
import WhatsNext from "./pages/WhatsNext/WhatsNext";
import PromoVideo from "./pages/PromoVideo/PromoVideo";
import promoVideo1 from "./videos/cpn-video-1.mp4";
import promoVideo2 from "./videos/cpn-video-2.mp4";
import ChatWidget from "./components/ChatWidget";

// Dashboard Wrapper Component
const DashboardWrapper = () => (
  <SidebarProvider>
    <Dashboard />
  </SidebarProvider>
);

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {/* Auth routes without navbar */}
        <Route path="/SignIn" element={<SignIn />} />
        {/* <Route path="/SignUp" element={<SignUp />} /> */}
        <Route path="/confirm-password" element={<ConfirmPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Dashboard routes with nested routing */}
        <Route path="/dashboard" element={<DashboardWrapper />}>
          <Route index element={<Dashboard />} />
          <Route path="timeshares" element={<Dashboard />} />
          <Route path="timeshares/:id" element={<TimeshareDetail />} />
          <Route path="consultations" element={<Dashboard />} />
          <Route path="chat" element={<Dashboard />} />
          <Route path="chat/:userId" element={<ChatWithUser />} />
        </Route>

        {/* Main routes with navbar */}
        <Route path="/" element={<Root />}>
          <Route index element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/FAQ" element={<FAQ />} />
          <Route path="/Process" element={<Process />} />
          <Route path="/Calendar" element={<Calendar />} />
          <Route path="/Reviews" element={<Reviews />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          {/* Lower-case too: the SMS consent box on the booking form and the
              A2P campaign registration both link to /terms, and a 404 on that
              link fails the carrier review outright. */}
          <Route path="/Terms" element={<Terms />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/Social" element={<Social />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/whats-next" element={<WhatsNext />} />
          <Route path="/video1" element={<PromoVideo src={promoVideo1} title="Consumer Protection Networks video 1" />} />
          <Route path="/video2" element={<PromoVideo src={promoVideo2} title="Consumer Protection Networks video 2" />} />
        </Route>
      </>,
    ),
  );

  return (
    <div className={`app`}>
      <MaintenanceBanner />
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;

const Root = () => {
  const { pathname } = useLocation();

  return (
    <div className={`App`}>
      <ScrollToTop />
      <Navbarr />
      {/* Home starts with a full-screen hero that is meant to sit under the
          navbar; every other page is pushed below it. */}
      <main className={pathname === "/" ? "" : "page-content"}>
        <Outlet />
      </main>
      <ChatWidget />
    </div>
  );
};
